import React from "react";
import DesktopNavbarSearch from "./DesktopNavbarSearch";
import MobileNavbarSearch from "./MobileNavbarSearch";

const normalizeLang = (lang) => (lang || "ru").toLowerCase();

export const getDisplayTitle = (book, lang) => {
  const l = normalizeLang(lang);
  if ((l === "uk" || l === "ua") && book.ukrTitle && book.ukrTitle.trim()) {
    return book.ukrTitle;
  }
  return book.title;
};


function NavbarSearch({ variant, ...props }) {
  if (variant === "desktop") {
    return <DesktopNavbarSearch {...props} />;
  }

  return <MobileNavbarSearch {...props} />;
}

export default NavbarSearch;
